import { TextField, Tooltip, Box } from "@mui/material";
import { useState } from "react";

const FieldText = ({ onChange, field, index, contextProps }) => {
  // Use context props passed from parent
  const { currentContext, shouldShowFieldInSection } = contextProps || {};
  
  // Get the label from field.label, field.title, or fallback to field.name
  const fieldLabel = field.label || field.title || field.name || `Field ${index + 1}`;
  const [isHovered, setIsHovered] = useState(false);
  
  // Check if this field should be visible in the current context and section
  const isVisible = shouldShowFieldInSection(field.name, field.category);
  
  // Create a detailed tooltip content with field metadata
  const tooltipContent = (
    <Box sx={{ p: 1, maxWidth: 300 }}>
      <div><strong>Field ID:</strong> {field.id || 'N/A'}</div>
      <div><strong>Name:</strong> {field.name || 'N/A'}</div>
      <div><strong>Type:</strong> {field.type || 'TEXT'}</div>
      <div><strong>Category:</strong> {field.category || 'N/A'}</div>
      <div><strong>Required:</strong> {(field.mandatory || field.required) ? 'Yes' : 'No'}</div>
      {field.isServiceField && <div><strong>Service Field:</strong> Yes</div>}
      {field.isStatic && <div><strong>Static Field:</strong> Yes</div>}
    </Box>
  );
  
  // Log field details to console when hovered
  const handleMouseEnter = () => {
    setIsHovered(true);
    console.log("%c FIELD DETAILS ", "background: #3F51B5; color: white; font-size: 12px; font-weight: bold; padding: 3px 6px; border-radius: 3px;");
    console.log({
      id: field.id || 'N/A',
      name: field.name || 'N/A',
      label: fieldLabel,
      type: field.type || 'TEXT',
      category: field.category || 'N/A',
      required: (field.mandatory || field.required) ? true : false,
      isServiceField: field.isServiceField || false,
      isStatic: field.isStatic || false,
      value: field.value
    });
  };
  
  const handleMouseLeave = () => {
    setIsHovered(false);
  };
  
  // If field is not visible in current context, don't render it
  if (!isVisible) {
    return null;
  }
  
  return (
    <Tooltip 
      title={tooltipContent}
      arrow
      placement="top"
    >
      <TextField
        required={field.mandatory || field.required}
        name={field.name || "description"}
        label={fieldLabel}
        fullWidth
        value={field.value || ""}
        onChange={(e) => onChange(e.target.value, field, index)}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        sx={{
          '& .MuiOutlinedInput-root': {
            borderColor: isHovered ? '#3F51B5' : 'inherit',
          },
          '& .MuiInputLabel-root': {
            color: isHovered ? '#3F51B5' : 'inherit',
          }
        }}
      />
    </Tooltip>
  );
};

export default FieldText;
